import { render } from "./StageProjects.vue?vue&type=template&id=20f04c94"
import script from "./StageProjects.vue?vue&type=script&lang=js"
export * from "./StageProjects.vue?vue&type=script&lang=js"

import "./StageProjects.vue?vue&type=style&index=0&id=20f04c94&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__